import { Alert, Box, Button, Collapse, Icon, IconButton } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import mfaBannerDismissal from "~/helpers/mfaBannerDismissal";
import { stringFormatDateTime } from "~/helpers/timestampFormat";
import { useAppDispatch } from "~/hooks/reduxHooks";
import { openPreferencesModal } from "~/store/layoutSlice";

interface MfaEnforcementBannerProps {
	graceDeadline: string | null;
}

const MfaEnforcementBanner = ({ graceDeadline }: MfaEnforcementBannerProps) => {
	const { t } = useTranslation("common");
	const dispatch = useAppDispatch();
	const [dismissed, setDismissed] = useState(() =>
		graceDeadline ? mfaBannerDismissal.isDismissed(graceDeadline) : false
	);

	const dismiss = () => {
		if (graceDeadline) mfaBannerDismissal.markDismissed(graceDeadline);
		setDismissed(true);
	};

	return (
		<Collapse in={!dismissed}>
			<Alert
				action={
					<Box sx={{ alignItems: "center", display: "flex", gap: 0.5 }}>
						<Button
							color="inherit"
							onClick={() => dispatch(openPreferencesModal("security"))}
							size="small"
							variant="outlined"
						>
							{t("shell.mfaBanner.enrollButton")}
						</Button>
						<IconButton aria-label={t("shell.mfaBanner.dismissAria")} color="inherit" onClick={dismiss} size="small">
							<Icon fontSize="small">close</Icon>
						</IconButton>
					</Box>
				}
				icon={<Icon sx={{ fontSize: 20 }}>shield</Icon>}
				severity="warning"
				sx={{ alignItems: "center", borderRadius: 0 }}
			>
				{graceDeadline
					? t("shell.mfaBanner.messageWithDeadline", { deadline: stringFormatDateTime(graceDeadline) })
					: t("shell.mfaBanner.message")}
			</Alert>
		</Collapse>
	);
};

export default MfaEnforcementBanner;
